export default {
	id: null,
	data: {},
	src: null,
	delay: 0,
};
